<template>
  <div class="">
    <div class="logo-box">
      <div class="windowsWidth">
        <img src="../assets/logo.png" />
      </div>
    </div>
    <!-- 导航 -->
    <div class="head-bj">
      <div class="windowsWidth">
        <el-menu :default-active="activeIndex" mode="horizontal" background-color='#bf001a' text-color='#fff'
          active-text-color='#fff' :router='true'>
          <el-menu-item v-for="item in navList" :key='item.index' :index="item.index"
            :route='item.url'>{{ item.title }}</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  props: { msg: String },
  data() {
    return {
      activeIndex: '1',
      navList: [{
        title: '网站首页',
        index: '1',
        url: '/'
      },
      {
        title: '政协概况',
        index: '2',
        url: '/category/1/1'
      },
      {
        title: '政协领导',
        index: '3',
        url: '/category/2/30'
      },
      {
        title: '政协要闻',
        index: '4',
        url: '/category/3/9'
      },
      {
        title: '会议活动',
        index: '/category/4/16',
        url: ''
      },
      {
        title: '委员履职',
        index: '/category/5/22',
        url: ''
      },
      {
        title: '学习园地',
        index: '/category/6/26',
        url: ''
      },

      ]
    }
  },
}
</script>
<style scoped lang="scss">
.logo-box {
  background-color: #f3eee8;
}

.el-menu {
  margin: 0;
  padding: 0;
  border-bottom: 0px;
}

.el-menu-item {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  width: 200px;
  border-bottom: 0px;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 0px;
}
</style>
